<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Adicionar Parque Tecnológico</h3>
          </div>
          <ParkForm :park="park" :errors="errors" :onSubmit="onSubmit"></ParkForm>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import ParkClient from '@/services/resource_client/park'
import ParkForm from '@/pages/parks/ParkForm'

export default {
  name: 'CreatePark',
  components: { Adminlte, ParkForm },
  data: function () {
    return {
      park: {},
      errors: {}
    }
  },
  methods: {
    onSubmit () {
      ParkClient.post(this.park)
      .then(r => { this.$router.push({ name: 'Parks' }) })
      .catch(e => { this.errors = e.response.data.errors })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreatePark.vue?5a8a7cea